import React, { useState, useEffect } from 'react';
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, Alert, CircularProgress } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import ModuleHub from '../components/ModuleHub';
import { getBankTransactions, reconcileTransaction } from '../../../services/api';

const BankReconciliation = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => { loadData(); }, []);
  const loadData = async () => {
    try { setLoading(true); const r = await getBankTransactions(); setItems(r.data || []); }
    catch (err) { setError(err.message); } finally { setLoading(false); }
  };

  const fmt = (v) => parseFloat(v || 0).toLocaleString('en-LK', { style: 'currency', currency: 'LKR' });

  return (
    <ModuleHub moduleId="bank-cash" showFeatures={false}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Button startIcon={<RefreshIcon />} onClick={loadData}>Refresh</Button>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {loading ? <CircularProgress /> : (
        <TableContainer component={Paper}><Table>
          <TableHead><TableRow><TableCell>Date</TableCell><TableCell>Account</TableCell><TableCell>Type</TableCell><TableCell>Description</TableCell><TableCell align="right">Amount</TableCell><TableCell>Reconciled</TableCell><TableCell>Actions</TableCell></TableRow></TableHead>
          <TableBody>{items.map(t => (
            <TableRow key={t.id}>
              <TableCell>{t.transaction_date}</TableCell>
              <TableCell>{t.bankAccount?.account_name}</TableCell>
              <TableCell>{t.transaction_type}</TableCell>
              <TableCell>{t.description}</TableCell>
              <TableCell align="right">{fmt(t.amount)}</TableCell>
              <TableCell><Chip label={t.is_reconciled ? 'Yes' : 'No'} size="small" color={t.is_reconciled ? 'success' : 'warning'} /></TableCell>
              <TableCell>
                {!t.is_reconciled && <Button size="small" onClick={() => reconcileTransaction(t.id, true).then(loadData)}>Reconcile</Button>}
                {t.is_reconciled && <Button size="small" onClick={() => reconcileTransaction(t.id, false).then(loadData)}>Undo</Button>}
              </TableCell>
            </TableRow>
          ))}</TableBody>
        </Table></TableContainer>
      )}
    </ModuleHub>
  );
};

export default BankReconciliation;
